import { Button } from "../../../../components/ui/button";
import { Link } from "react-router-dom";

const CTA: React.FC = () => {
	return (
		<section className="py-16 bg-blue-600">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
				<h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
					新しい知識とスキルを身につけませんか？
				</h2>
				<p className="text-xl text-blue-100 mb-8">
					初心者から上級者まで、レベルに合わせた勉強会を開催しています
				</p>
				<div className="flex flex-col sm:flex-row gap-4 justify-center">
					<Button
						asChild
						size="lg"
						className="bg-white text-blue-600 hover:bg-blue-50"
					>
						<Link to="/study-groups/schedule">参加申し込み</Link>
					</Button>
					<Button
						asChild
						size="lg"
						variant="outline"
						className="text-white border-white hover:bg-blue-500"
					>
						<Link to="/contact">お問い合わせ</Link>
					</Button>
				</div>
			</div>
		</section>
	);
};

export default CTA;
